import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { StudentsRemovalRequestsPendingFilters } from './StudentsRemovalRequestsPendingFilters';
import { StudentsRemovalRequestsPendingFiltersLoader } from './StudentsRemovalRequestsPendingFiltersLoader';
import {
  StudentsRemovalRequestsPendingListConsumer,
  StudentsRemovalRequestsPendingListLoader,
} from './StudentsRemovalRequestsPendingListLoader';
import { StudentsRemovalRequestsPendingTable } from './StudentsRemovalRequestsPendingTable';
import { StudentsRemovalRequestsPendingTablePagination } from './StudentsRemovalRequestsPendingTablePagination';

export function StudentsRemovalRequestsPending() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_MANAGEMENT_PENDING,
  );
  const texts = useMemo(() => {
    return {
      body: t('requests-pending.body'),
    };
  }, [t]);

  return (
    <>
      <StudentsRemovalRequestsPendingListLoader>
        <p className="fs-18">{texts.body}</p>
        <StudentsRemovalRequestsPendingFiltersLoader>
          {({ data }) => (
            <>
              <StudentsRemovalRequestsPendingFilters data={data} />
              <StudentsRemovalRequestsPendingListConsumer>
                {({ data, loading }) => {
                  return (
                    <>
                      <StudentsRemovalRequestsPendingTable
                        data={data?.data ?? []}
                        loading={loading}
                      />
                      {!!data && !loading && data.total_pages > 1 && (
                        <StudentsRemovalRequestsPendingTablePagination
                          total={data.total}
                          totalPages={data.total_pages}
                        />
                      )}
                    </>
                  );
                }}
              </StudentsRemovalRequestsPendingListConsumer>
            </>
          )}
        </StudentsRemovalRequestsPendingFiltersLoader>
      </StudentsRemovalRequestsPendingListLoader>
    </>
  );
}
